import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/units'

export default defineStore('dashboard-units',
  storeModule.createStoreModule('dashboard-units', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
